const feePaymentEnum = Object.freeze({
  PAID: "Paid", 
  PENDING: "Pending",
});
export default feePaymentEnum;
